"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactPreferenceLabels = exports.InterestAvailabilityLabels = exports.InterestShiftLengthLabels = exports.InterestShiftTypeLabels = exports.InterestWorkTypeLabels = exports.TravelWillingnessLabels = exports.WorkTypePreferenceLabels = void 0;
exports.formatInterestChoices = formatInterestChoices;
exports.WorkTypePreferenceLabels = {
    PER_DIEM: 'Some days here and there',
    LONG_TERM: "I'm looking for a long term opportunity",
    OPEN_TO_ANYTHING: "I'm open to anything!",
};
exports.TravelWillingnessLabels = {
    WILLING: 'Yes',
    WILLING_WITH_STIPEND: 'Yes, but I need a stipend',
    NOT_WILLING: 'No',
};
exports.InterestWorkTypeLabels = {
    FULL_TIME: 'Full time',
    PART_TIME: 'Part time',
    PER_DIEM: 'Per diem',
    OTHER: 'Other',
};
exports.InterestShiftTypeLabels = {
    DAY: 'Day',
    EVENING: 'Evening',
    NIGHT: 'Night',
    WEEKEND: 'Weekend',
    ROTATING: 'Rotating',
    OTHER: 'Other',
};
exports.InterestShiftLengthLabels = {
    EIGHT_HOURS: '8 hours',
    TEN_HOURS: '10 hours',
    TWELVE_HOURS: '12 hours',
    FLEXIBLE: 'Flexible',
};
exports.InterestAvailabilityLabels = {
    ASAP: 'ASAP',
    WITHIN_90_DAYS: 'Within 90 days',
    OTHER: 'Other',
};
exports.ContactPreferenceLabels = {
    TEXT: 'Text',
    EMAIL: 'Email',
    PHONE: 'Phone',
};
function formatInterestChoices(values, labels, otherText) {
    const parts = values
        .map((value) => value === 'OTHER' && otherText?.trim()
        ? otherText.trim()
        : (labels[value] ?? value))
        .filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : null;
}
//# sourceMappingURL=facility-interest-labels.js.map